import $ from 'jquery';

/**
 * @param {JQuery<HTMLElement>} $preview
 */
export const initOverlayHighlight = ($preview) => {
	const $W = mpro.get$W();
	const $B = mpro.get$B();
	let pageScrolled = false;

	if ($preview.closest('.modal-content').length) {
		$preview = $preview.closest('.modal-content');
	}

	if ($preview.length) {
		$B[0].style.overflowY = 'hidden';
	}

	drawOverlayHighlight($preview);

	setTimeout(function () {
		drawOverlayHighlight($preview);

		if (!pageScrolled) {
			mpro.scrollToElement($preview, {offsetY: 100});
		}
	}, 500);

	const notification_bar = $('#notification_bar');
	if (notification_bar.length) {
		notification_bar.on('transitionend', (e) => {drawOverlayHighlight($preview)});
	}

	$W.on('resize.draw-overlay-highlight', { $preview }, (e) => {
		drawOverlayHighlight($preview);
	});

	window.addEventListener("load", function(){
		drawOverlayHighlight($preview);
	});
	window.addEventListener("DOMContentLoaded", function(){
		drawOverlayHighlight($preview);
	});

	// run handler on scroll
	document.addEventListener('scroll', function(){
		drawOverlayHighlight($preview);
		pageScrolled = true;
	}, { passive: true });
};

const isOverflown = (element, offset) => {
	const positionOffset = {
		...{x: 0, y: 0},
		...(offset || {}),
	};
	const getOffset = function( el ) {
		var _x = 0;
		var _y = 0;
		while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
			_x += el.offsetLeft - el.scrollLeft;
			_y += el.offsetTop - el.scrollTop;
			el = el.offsetParent;
		}
		return { y: _y + positionOffset.y, x: _x + positionOffset.x };
	};
	const _pos = getOffset(element);
	let _topElement;
	const elements = document.elementsFromPoint(_pos.x, _pos.y);
	_topElement = elements.shift();

	// Exclude overlayer
	if (_topElement.tagName === 'TD') {
		_topElement = elements.shift();
	}

	//Returns a boolean of whether this is this the same element?
	return _topElement !== element;
}


/**
 * Redirect to the connect backed
 *
 * @param {JQuery<HTMLElement>} $preview
 */
const drawOverlayHighlight = ($preview) => {
	const $B = mpro.get$B();
	const $W = mpro.get$W();

	let boundingRect = $preview[0].getBoundingClientRect();
	if ($preview.closest('#notification_bar').length && isOverflown($preview[0], {x: 2, y: 2})) {
		boundingRect.height = 0;
	}

	$('#overlay_highlight').remove();

	if ($preview.attr('class').includes('--narrow') && !($preview.attr('class').includes('bslot-video--narrow') && $preview.attr('class').includes('bslot-video--responsive'))) {
		$B.append(`<table id="overlay_highlight" class="overlay-highlight">
			<tr>
				<td rowspan="3" style="width: calc(${boundingRect.left}px + ${$preview.css('padding-left')});"></td>
				<td style="height: ${boundingRect.top + $W[0].scrollY}px;"></td>
				<td rowspan="3"></td>
			</tr>
			<tr><td class="window" style="width: calc(${boundingRect.width}px - ${$preview.css('padding-left')} - ${$preview.css('padding-right')}); height: ${boundingRect.height}px;"></td></tr>
			<tr><td></td></tr>
		</table>`);
	}
	else {
		$B.append(`<table id="overlay_highlight" class="overlay-highlight">
			<tr>
				<td rowspan="3" style="width: ${boundingRect.left}px;"></td>
				<td style="height: ${boundingRect.top + $W[0].scrollY}px;"></td>
				<td rowspan="3"></td>
			</tr>
			<tr><td class="window" style="width: ${boundingRect.width}px; height: ${boundingRect.height}px;"></td></tr>
			<tr><td></td></tr>
		</table>`);
	}
};